const DIR_LTR = 'ltr';

export function getHtmlDir() {
  return document.querySelector('html').getAttribute('dir') || DIR_LTR;
}

export function isLTRDir() {
  return getHtmlDir() === DIR_LTR;
}
